import React from 'react';
import {useAiCallSession} from '../hooks/useAiCallSession';
import {useAiCallParentTabAvailability} from '../hooks/useAiCallParentTabAvailability';

/**
 * AI-call child tab: when it goes away, asks the parent tabs to end the call and set the agent
 * Available again (withdrawn if it was really a refresh).
 * Parent tab: does both once the child has stayed closed for the grace period, and updates
 * navbar "Available" when another tab signals it did so via localStorage.
 */
const AiCallSessionRegistration = () => {
  useAiCallSession();
  useAiCallParentTabAvailability();
  return null;
};

export default AiCallSessionRegistration;
